import React, { type MouseEvent } from 'react';
import { ShieldCheckIcon, ArrowRightIcon, LockIcon } from 'lucide-react';
import { OFFER_ID } from '../../utils/scrollToOffer';
import { CHECKOUT_URL, openCheckout } from '../../utils/checkout';
const included = ['Guía completa Curly Seducción (70 páginas)', 'Test de porosidad y patrón', 'Bono 1 · Guía de ingredientes', 'Bono 2 · 12 recetas caseras', 'Bono 3 · Calendario de 30 días'];
export function OfferSection() {
  // Atajo: doble clic en cualquier punto del bloque de precio lleva al checkout.
  // El botón sigue siendo la vía principal y accesible.
  const handleCardDoubleClick = (event: MouseEvent<HTMLDivElement>) => {
    if ((event.target as HTMLElement).closest('a')) return;
    openCheckout();
  };
  return <section id={OFFER_ID} className="scroll-mt-6 border-b border-white/5 bg-ink py-20" aria-labelledby="offer-title" data-id="element-86" data-mp="2r1zisxjowy38">
      <div className="mx-auto w-full max-w-4xl px-6" data-id="element-87" data-mp="3jkmw3qsg38tr">
        <div onDoubleClick={handleCardDoubleClick} className="rounded-xl border border-gold/30 bg-cocoa p-8 sm:p-12" data-id="element-88" data-mp="3jmhfh0o2isvq">
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-gold" data-id="element-89" data-mp="365eokg3g3x1n">
            Oferta de lanzamiento
          </p>
          <h2 id="offer-title" className="mt-4 font-display text-3xl text-cream sm:text-4xl" data-id="element-90" data-mp="3kuu9hfgap89f">
            Todo el método, un solo pago
          </h2>

          <div className="mt-8 grid gap-10 sm:grid-cols-[1fr_auto] sm:items-start" data-id="element-91" data-mp="3ttocpoo4swvy">
            <ul className="space-y-2.5" data-id="element-92" data-mp="3psw48xn32w0q">
              {included.map(item => <li key={item} className="flex items-start gap-3 text-sand" data-id="element-93" data-mp="3puypz5h7e2zn">
                  <span aria-hidden="true" className="mt-2 h-1 w-1 shrink-0 rounded-full bg-gold" data-id="element-94" data-mp="7m7zj8vy4avl" />
                  <span data-id="element-95" data-mp="2opmp7et5bib">{item}</span>
                </li>)}
            </ul>

            <div className="sm:text-right" data-id="element-96" data-mp="29ew4pns5h8e0">
              <p className="text-sm text-sand/70" data-id="element-97" data-mp="24fj84bbh8my8">
                Precio normal <span className="line-through" data-id="element-98" data-mp="24hdvrxe4ut60">$27.00</span>
              </p>
              <p className="mt-1 font-display text-6xl leading-none text-gold-soft" data-id="element-99" data-mp="8dg47zmkklmt">$6.39</p>
              <p className="mt-2 text-sm text-sand" data-id="element-100" data-mp="dc0vh9jufuz4">Pago único · Descarga inmediata</p>
              <p className="mt-3 inline-flex items-center rounded-full border border-gold/40 px-3 py-1 text-xs font-semibold uppercase tracking-[0.14em] text-gold" data-id="element-101" data-mp="hbrug0jixheq">
                76% de descuento hoy
              </p>
            </div>
          </div>

          <a href={CHECKOUT_URL} rel="noopener noreferrer" onClick={openCheckout} className="add-to-cart mt-10 flex w-full items-center justify-center gap-2 rounded-full bg-gold px-8 py-4 text-sm font-semibold uppercase tracking-[0.14em] text-ink transition-colors duration-150 ease-out hover:bg-gold-soft focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/40" data-id="element-102" data-mp="r969bvpsty4x">
            Quiero mis rizos definidos
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-103" data-mp="1f13cyzj3hjuy" />
          </a>

          <p className="mt-4 flex items-center justify-center gap-2 text-xs text-sand/80" data-id="element-104" data-mp="1p5bcfr18tdit">
            <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-105" data-mp="1k4dsb8woa9eo" />
            Pago seguro · Recibes el acceso en tu correo al instante
          </p>
        </div>

        <div className="mt-8 flex flex-col items-start gap-4 border border-white/10 p-6 sm:flex-row sm:items-center" data-id="element-106" data-mp="1b50j8hcgnmuh">
          <ShieldCheckIcon className="h-10 w-10 shrink-0 text-gold" aria-hidden="true" data-id="element-107" data-mp="27v9i60hkiuja" />
          <div data-id="element-108" data-mp="22ver9wxsm4y8">
            <h3 className="font-display text-2xl text-cream" data-id="element-109" data-mp="22vn81zx1duep">Garantía de 30 días</h3>
            <p className="mt-1 text-sand" data-id="element-110" data-mp="1y4ol4hhjly2h">
              Prueba el método un mes completo. Si tu rizo no cambia, escribes a soporte y te
              devolvemos el 100%. Sin preguntas.
            </p>
          </div>
        </div>
      </div>
    </section>;
}